<template>
    <vs-chip v-if="status=='Invited'" transparent color="dark">Invited</vs-chip>
    <vs-chip v-else-if="status=='Accepted'" transparent color="success">Accepted</vs-chip>
    <vs-chip v-else-if="status=='Rejected'" transparent color="danger">Rejected</vs-chip>
    <vs-chip v-else-if="status=='NotInvited'" transparent color="primary">Not Invited Yet</vs-chip>
    <vs-chip v-else transparent color="warning">Pending</vs-chip>
</template>

<script>
export default {
  name: 'InvitationStatus',
  props: {
    status: {
      type: String,
      required: false,
      default: 'NotInvited'
    },
  },
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'Open') return 'success'
        else if (value === 'Closed') return 'danger'
        else if (value === 'Visible') return 'success'
        else if (value === 'Hidden') return 'danger'
        else return 'warning'
      }
    }
  }
}
</script>